import moment from 'moment'
import { isString } from '../appRedux/actions'
import { postDataToApp } from '../appRedux/actions/MobAppFn'
import { PostAppTypes } from '../constants/MobAppConstants'
import {
  getIOSOpenCloseFormattedPrint,
  getIOSSalesFormattedPrint,
  getIOSZeeFormattedPrint,
  getOpenCloseFormattedPrint,
  getSalesFormattedPrint,
  getZeeFormattedPrint
} from '../appRedux/actions/TabletPrintStringHelper'

export function TabSaleString (
  data,
  currency,
  dec,
  templateData,
  allowPrintNote,
  allowDiscountShow,
  ip,
  port,
  printCopies,
  openDrawer,
  deviceName,
  platform
) {
  try {
    if (data) {
      const decimal = dec ? dec : 2
      const today =
        data && data.sellDate
          ? moment(data.sellDate).format('LLLL')
          : moment().format('LLLL')

      let tempData = false
      if (templateData) {
        tempData = { ...templateData }
        if (tempData.headInfoHtml && !tempData.headInfoHtml.includes('null')) {
          tempData.headInfoHtml = rawHtmlProcessToPrinterLib(
            tempData.headInfoHtml
          )
        }

        if (tempData.footerHtml && !tempData.footerHtml.includes('null')) {
          tempData.footerHtml = rawHtmlProcessToPrinterLib(tempData.footerHtml)
        }
      }
      const toTabPrint =
        platform == 'ios'
          ? getIOSSalesFormattedPrint(
              tempData,
              data,
              today,
              currency,
              decimal,
              allowPrintNote,
              allowDiscountShow
            )
          : getSalesFormattedPrint(
              tempData,
              data,
              today,
              currency,
              decimal,
              allowPrintNote,
              allowDiscountShow
            )

      let print_rev = printCopies ?? 1
      if (print_rev && print_rev > 0) {
        let drawer = openDrawer || false
        let opened = false
        for (let i = 0; i < print_rev; i++) {
          if (opened) drawer = false
          if (drawer) opened = true
          postDataToApp(PostAppTypes.RECIEPT_PRINT, {
            ip: ip,
            port: port,
            content: toTabPrint,
            // printCopies,
            openDrawer: drawer,
            deviceName,
            platform,
            type: 'sale'
          })
        }
      }
    }
  } catch (ex) {
    console.log('print TabSaleString error ====> ', ex)
  }
}

function rawHtmlProcessToPrinterLib (htmlString) {
  let result =
    htmlString && isString(htmlString) && htmlString.includes('[C]')
      ? htmlString
      : ''
  if (htmlString && isString(htmlString) && !htmlString.includes('[C]')) {
    const mapping = {
      '<strong>': '<b>',
      '</strong>': '</b>',
      '<em>': '<b>',
      '</em>': `</b>`,
      '<h1>': "<font size='big'>",
      '</h1>': '</font>',
      '<h2>': "<font size='tall'>",
      '</h2>': '</font>',
      '<h3>': "<font size='tall'>",
      '</h3>': '</font>',
      '&nbsp;': '\n',
      '<p>': '',
      '</p>': '',
      '<br />': '\n'
    }

    let convertedString = htmlString
    Object.entries(mapping).forEach(([key, value]) => {
      convertedString = convertedString.replace(new RegExp(key, 'g'), value)
    })

    result = convertedString
    // aligning center
    if (result) {
      result = result.includes('\r') ? result.replaceAll('\r', '') : result
      let res = result.includes('\n') ? result.split('\n') : []
      if (res.length > 0) {
        let sstring = ''
        res.map((q, key) => {
          if (q) {
            sstring += key != 0 ? `\n[C]${q}` : `[C]${q}`
          }
        })
        result = sstring
      } else {
        result = `[C]${result}`
      }
    }
  }

  if (result && result.includes('<big>')) {
    result = result.replace('<big>', '').replace('</big>', '')
  }

  return result
}

export function TabZeeString (
  data,
  currency,
  dec,
  showSaleDate,
  ip,
  port,
  showTotalAmount,
  deviceName,
  platform
) {
  try {
    if (data) {
      const decimal = dec ? dec : 2
      const today =
        data && data.sellDate
          ? moment(data.sellDate).format('LLLL')
          : moment().format('LLLL')

      const toTabPrint =
        platform == 'ios'
          ? getIOSZeeFormattedPrint(
              data,
              today,
              currency,
              decimal,
              showSaleDate,
              showTotalAmount
            )
          : getZeeFormattedPrint(
              data,
              today,
              currency,
              decimal,
              showSaleDate,
              showTotalAmount
            )
      postDataToApp(PostAppTypes.RECIEPT_PRINT, {
        ip: ip,
        port: port,
        content: toTabPrint,
        deviceName,
        platform,
        type: 'zee'
      })
    }
  } catch (ex) {
    console.log('print TabZeeString error ====> ', ex)
  }
}

export function TabOpenCloseString (
  data,
  currency,
  dec,
  storeInfo,
  ip,
  port,
  deviceName,
  platform
) {
  try {
    if (data) {
      const decimal = dec ? dec : 2
      const today =
        data && data.sellDate
          ? moment(data.sellDate).format('LLLL')
          : moment().format('LLLL')

      const toTabPrint =
        platform == 'ios'
          ? getIOSOpenCloseFormattedPrint(
              data,
              today,
              currency,
              decimal,
              storeInfo
            )
          : getOpenCloseFormattedPrint(
              data,
              today,
              currency,
              decimal,
              storeInfo
            )
      postDataToApp(PostAppTypes.RECIEPT_PRINT, {
        ip: ip,
        port: port,
        content: toTabPrint,
        deviceName,
        platform,
        type: 'open'
      })
    }
  } catch (ex) {
    console.log('print TabOpenCloseString error ====> ', ex)
  }
}
